export default class HeaderFieldConstant {
  // Text Field Values
  public static MachineName = 'Machine Name'
  public static RevitVersion = 'RevitVersion'
  public static LatestDayOpened = 'Latest Day Opened'
  public static Name = 'Name'
  public static Email = 'Email'
  public static CreatedAt = 'Created At'
  public static UpdatedAt = 'UpdatedAt'

  // Value Field values
  public static revitVersion = 'revitVersion'
  public static machineName = 'machineName'
  public static logDate = 'logDate'
  public static orgName = 'name'
  public static email = 'email'
  public static createdAt = 'createdAt'
  public static updatedAt = 'updatedAt'
  public static Organization = 'Organization'
  // Private constructor to stop direct instancing as this should be a static class.
  private constructor() {}
}
